

// Main Function
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Drawer from "@mui/material/Drawer";
import * as React from "react";
import QueryFinancialsDropdownVersion from "./QueryFinancialsDropdownVersion";
import MenuIcon from '@mui/icons-material/Menu';
import {Stack, Tooltip, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import TableRowsIcon from '@mui/icons-material/TableRows';
import {changeContractDrilldownCS} from "../../contractDrilldownSliceCS";
import QueryFinancialsGridVersionNarrow from "./QueryFinancialsGridVersionNarrow";
import QueryFinancialsGridVersionWide from "./QueryFinancialsGridVersionWide";
import Button from "@mui/material/Button";


export default function QueryFinancialsDrawer(setFinancialQueryOpen, financialQueryOpen) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const dispatchData = useDispatch();

    const selectorQfDrawerState = useSelector((state) => state.contractDrilldownSlcCS.value.QfDrawerState);
    const selectorQfDrawerMode = useSelector((state) => state.contractDrilldownSlcCS.value.QfDrawerMode);

    const [clearForm, setClearForm] = useState(false);


    function handleDropdownClick() {
        dispatchData(changeContractDrilldownCS({QfDrawerMode: "Dropdown" }));
    };

    function handleGridNarrowClick() {
        dispatchData(changeContractDrilldownCS({QfDrawerMode: "GridNarrow" }));
    };

    function handleGridWideClick() {
        dispatchData(changeContractDrilldownCS({QfDrawerMode: "GridWide" }));
    };


    function closeQfDrawer() {
        dispatchData(changeContractDrilldownCS({QfDrawerState: false }));
    };




    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorQfDrawerState}
                initialState={{open: false}}
                onClose={closeQfDrawer}
            >
                <Box sx={{height: 20}}/>
                {/*{queryFinancialsForm()}*/}
                <Typography sx={{pl: 2, fontSize: 28, fontWeight: 'bold'}} style={{cursor:'pointer'}}  onClick={() => closeQfDrawer()}>Account Form</Typography>
                <Stack sx={{pl: 2}} direction="row" spacing={2}     alignItems="center" >
                    <Tooltip enterDelay={1000} title={"View as Dropdown lists"}>
                <MenuIcon
                    sx={{
                        color: selectorQfDrawerMode === 'Dropdown'
                            ? 'black'
                            : 'primary.main',
                        cursor: 'pointer'
                    }}
                    onClick={handleDropdownClick} />
                    </Tooltip>

                    <Tooltip enterDelay={1000} title={"View as single-row Grids"}>
                <ViewColumnIcon
                    sx={{
                        color: selectorQfDrawerMode === 'GridNarrow'
                            ? 'black'
                            : 'primary.main',
                        cursor: 'pointer'
                    }}
                    onClick={handleGridNarrowClick} />
                    </Tooltip>

                    <Tooltip enterDelay={1000} title={"View as wide Grids"}>
                <TableRowsIcon
                    sx={{
                        color: selectorQfDrawerMode === 'GridWide'
                            ? 'black'
                            : 'primary.main',
                        cursor: 'pointer'
                    }}
                    onClick={handleGridWideClick} />
                    </Tooltip>
                    <Button onClick={() => setClearForm(prev => !prev)}>Clear Form</Button>
                </Stack>
                {selectorQfDrawerMode === "Dropdown" && <QueryFinancialsDropdownVersion/>}
                {selectorQfDrawerMode === "GridNarrow" && <QueryFinancialsGridVersionNarrow/>}
                {selectorQfDrawerMode === "GridWide" && <QueryFinancialsGridVersionWide
                    clearForm={clearForm}
                />}

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************


}